var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.0001V15.0001H16V19.0001H0ZM2 13.0001V10.0001L8.625 3.3751L11.625 6.3751L5 13.0001H2ZM3.5 11.5001H4.375L9.5 6.3751L8.625 5.5001L3.5 10.6251V11.5001ZM12.688 5.3121L9.688 2.3121L10.708 1.2921C10.9027 1.06943 11.139 0.961767 11.417 0.969101C11.6943 0.975767 11.9303 1.08343 12.125 1.2921L13.708 2.8751C13.9027 3.06977 13.9967 3.30243 13.99 3.5731C13.9827 3.84377 13.8887 4.08343 13.708 4.2921L12.688 5.3121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEditIcon);
export default __webpack_public_path__ + "static/media/white-edit-icon.3bd651749a3a9fec54450ac38be85ce3.svg";
export { ForwardRef as ReactComponent };